import { OrganizationUrlProps, RolesUrlProps } from "@logic";
import { GetRolesResponse, newGetFunction } from "@src/service";
import { rolesUrl, roleUrl } from "./urls";

export const getRoles = newGetFunction<OrganizationUrlProps, GetRolesResponse>(rolesUrl)
export const getRole = newGetFunction<RolesUrlProps, GetRolesResponse>(roleUrl)
